<template>
  <main>
    <div class="box">
      <section class="info">
        <figure>
          <el-carousel class="banner">
            <el-image class="img" :src="imgs[i]" fit="fit"></el-image>

            <!-- <el-carousel-item v-for="(item, i) in imgs" :key="i">
              <el-image class="img" :src="item" fit="fit"></el-image>
            </el-carousel-item> -->
          </el-carousel>
          <div class="card-carousel-wrapper">
            <div
              class="card-carousel--nav__left"
              @click="moveCarousel(-1)"
              :disabled="atHeadOfList"
            ></div>
            <div class="card-carousel">
              <div class="card-carousel--overflow-container">
                <div
                  class="card-carousel-cards"
                  :style="{
                    transform: 'translateX' + '(' + currentOffset + 'px' + ')',
                  }"
                >
                  <div
                    class="card-carousel--card"
                    v-for="(item, i) in imgs"
                    :key="i"
                  >
                    <img
                      :class="im == i ? 'im' : ''"
                      @click="dianji(i)"
                      :src="item"
                      v-on:mouseover="mover(i)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="card-carousel--nav__right"
              @click="moveCarousel(1)"
              :disabled="atEndOfList"
            ></div>
          </div>
          <!-- <dl class="date">
            <dt>
              <nav>
                <span 
                  :class="{on : i === submit.month}" 
                  v-for="(v, i) in tourGroups" :key="i"
                  @click="changeSubmit('month', i)">{{v.y}}年{{v.m + 1}}月</span>
              </nav>
              <p>
                <span>日</span>
                <span>一</span>
                <span>二</span>
                <span>三</span>
                <span>四</span>
                <span>五</span>
                <span>六</span>
              </p>
            </dt>
            <dd>
              <p 
                v-for="(v, i) in getGroups" 
                :key="i"
                :class="{on: v.on, selected: submit.day && v.id === submit.day.id }"
                @click="changeDay(v)">
                <b>{{v.day}}</b>
                <span>{{v.adult_price || ''}}</span>
              </p>
            </dd>
          </dl> -->
        </figure>
        <div class="desc">
          <h3>{{ info.full_title }}</h3>
          <p>{{ info.profile }}</p>
          <ul class="ul">
            <li>
              <!-- <span>选择出行日期</span> -->
              <span class="h">选择颜色</span>
              <div class="dd" v-for="(item, i) in color" :key="i">
                <div
                  :class="color_i == i ? 'bor' : ''"
                  class="item"
                  @click="colors(i)"
                >
                  <img
                    src="https://img14.360buyimg.com/n9/s40x40_jfs/t1/197456/23/20297/35201/6231b04dE4c0840de/e89ebf523380c753.jpg"
                    alt=""
                  />
                  <i>{{ item.name }}</i>
                </div>
              </div>

              <!-- <el-date-picker
                type="date"
                ref="day"
                v-model="submit.day"
                value-format="yyyy-MM-dd"
                :picker-options="dayOptions"
                placeholder="选择日期"
                @change="dataSearch"
              >
              </el-date-picker> -->
            </li>
            <li>
              <span class="h">选择版本</span>
              <div class="dd" v-for="(item, i) in banben" :key="i">
                <div
                  :class="banben_i == i ? 'bor' : ''"
                  class="item"
                  @click="banbens(i)"
                >
                  <i>{{ item.name }}</i>
                </div>
              </div>
              <!-- <div class="count">
                <el-popover
                  placement="bottom-start"
                  size="small"
                  title="价格提示"
                  width="100"
                  trigger="hover"
                  :content="
                    submit.day ? '¥' + submit.day.child_price : '请选择日期'
                  "
                >
                  <span slot="reference">成人</span>
                </el-popover>
                <el-input-number
                  v-model="submit.adult"
                  size="small"
                  :min="0"
                  :step="1"
                  @change="datanumberadult"
                ></el-input-number>
                <el-popover
                  placement="bottom-start"
                  title="价格提示"
                  width="100"
                  trigger="hover"
                  :content="
                    submit.day ? '¥' + submit.day.child_price : '请选择日期'
                  "
                >
                  <span class="ml" slot="reference">儿童</span>
                </el-popover>
                <el-input-number
                  v-model="submit.child"
                  size="small"
                  :min="0"
                  :step="1"
                  @change="datanumberchild"
                ></el-input-number>
              </div> -->
            </li>
            <li>
              <span class="h">购买方式</span>
              <div class="dd" v-for="(item, i) in taocan" :key="i">
                <div
                  :class="taocan_i == i ? 'bor' : ''"
                  class="item"
                  @click="taocans(i)"
                >
                  <i>{{ item.name }}</i>
                </div>
              </div>
              <!-- <div class="plane">
                <section
                  class="item"
                  v-for="v in info.travel_flights"
                  :key="v.id"
                >
                  <header>
                    <b>{{ v.airline_name }}</b>
                    <span>航班: {{ v.flight_number }}</span>
                  </header>
                  <div class="cont">
                    <p>
                      <b>{{ v.from_place }}</b>
                      <span>出发: {{ v.from_time }}</span>
                    </p>
                    <i class="icon-feiji800"
                      ><span>(D{{ v.days_of_num }})</span></i
                    >
                    <p>
                      <b>{{ v.to_place }}</b>
                      <span>出发: {{ v.to_time }}</span>
                    </p>
                  </div>
                </section>
              </div> -->
            </li>
            <li class="total">
              <p>
                <span>总价:</span><b class="price">{{ getTotal }}</b>
              </p>
              <button @click="addOrder">立即预订</button>
              <!-- <button>立即预订</button> -->
            </li>
          </ul>
        </div>
      </section>
      <div class="detail">
        <nav>
          <span :class="{ on: getScrollIndex === 0 }" @click="toDom(0)"
            >产品特色</span
          >
          <span :class="{ on: getScrollIndex === 1 }" @click="toDom(1)"
            >每日行程</span
          >
          <span
            :class="{ on: getScrollIndex === i + 2 }"
            @click="toDom(i + 2)"
            v-for="(v, i) in info.travel_notices"
            :key="v.id"
            >{{ v.title }}</span
          >
        </nav>
        <ul class="content">
          <li>
            <h4 id="nodes0">产品特色</h4>
            <div class="nodes" v-html="info.content_html"></div>
          </li>
          <li>
            <h4 id="nodes1">
              <span>每日行程</span>
              <p>
                <b
                  :class="{ on: strokeShowType === 0 }"
                  @click="strokeShowType = 0"
                  ><i class="icon-tupian"></i><span>图文行程</span></b
                >
                <b
                  :class="{ on: strokeShowType === 1 }"
                  @click="strokeShowType = 1"
                  ><i class="icon-rili-copy"></i><span>日历行程</span></b
                >
              </p>
            </h4>
            <ul v-show="strokeShowType === 0" class="line">
              <li v-for="(v, i) in info.travel_schedules" :key="v.id">
                <h5>
                  <b>第 {{ i + 1 }} 天</b>{{ v.title }}
                </h5>
                <div class="eat">
                  <p>
                    <span>早餐</span><i :class="v.breakfast | checkFood"></i>
                  </p>
                  <p><span>午餐</span><i :class="v.lunch | checkFood"></i></p>
                  <p><span>晚餐</span><i :class="v.dinner | checkFood"></i></p>
                </div>
                <p class="desc" v-html="v.content"></p>
                <div
                  class="bold"
                  v-for="s in v.travel_datas"
                  :key="s.id"
                  @click="openDialog(s)"
                >
                  <h6>
                    <b>{{ s.title }}</b>
                  </h6>
                  <div class="imgs">
                    <img
                      :src="imgUrl + i"
                      v-for="i in s.pic_arr.split(',')"
                      :key="i"
                      alt=""
                    />
                  </div>
                  <p class="nodes" v-html="s.content_html"></p>
                </div>
              </li>
            </ul>
            <el-table
              v-show="strokeShowType === 1"
              class="tabble"
              border
              background
              :data="info.travel_schedules"
            >
              <el-table-column label="行程">
                <template slot-scope="s">
                  <b
                    >第<span>{{ s.$index + 1 }}</span
                    >天</b
                  >
                  <p>{{ s.row.title }}</p>
                </template>
              </el-table-column>
              <el-table-column label="用餐">
                <template slot-scope="s">
                  <div class="food">
                    <p>
                      <span>早餐</span
                      ><i :class="s.row.breakfast | checkFood"></i>
                    </p>
                    <p>
                      <span>午餐</span><i :class="s.row.lunch | checkFood"></i>
                    </p>
                    <p>
                      <span>晚餐</span><i :class="s.row.dinner | checkFood"></i>
                    </p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="景点&活动">
                <template slot-scope="s">
                  <p
                    class="main"
                    v-for="v in s.row.travel_datas"
                    :key="v.id"
                    @click="openDialog(v)"
                  >
                    {{ v.title }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column prop="hotel_des" label="酒店"></el-table-column>
            </el-table>
          </li>
          <li v-for="(v, i) in info.travel_notices" :key="v.id">
            <h4 :id="'nodes' + (i + 2)">{{ v.title }}</h4>
            <div class="node_box">
              <!-- <b>{{v.title}}</b> -->
              <p class="nodes" v-html="v.content_html"></p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog
      :visible.sync="showDialog"
      custom-class="pop"
      width="1000px"
      :title="dialog.title"
    >
      <div class="cont">
        <el-carousel class="pic" width="600px" height="400px">
          <el-carousel-item v-for="v in dialogImgs" :key="v">
            <img :src="v" alt="" />
          </el-carousel-item>
        </el-carousel>
        <div class="nodes" v-html="dialog.content_html"></div>
      </div>
    </el-dialog>
  </main>
</template>

<script>
import $tour from "@api/tour";
import moment from "moment";
export default {
  data() {
    return {
      info: {},
      tourGroups: [],
      submit: {
        month: 0,
        day: null,
        adult: 0,
        child: 0,
      },
      top: 0,
      strokeShowType: 0,
      showDialog: false,
      dialog: {},

      currentOffset: 0,
      windowSize: 5,
      paginationFactor: 82,
      i: 0,
      im: 0,
      day: "",
      dayOptions: {
        disabledDate: (date) => {
          return date.getTime() < Date.now() - 8.64e7;
        },
      },
      shuliang: false,
      hangban: false,
      color: [
        { id: 0, name: "蓝色" },
        { id: 1, name: "红色" },
        { id: 2, name: "绿色" },
        { id: 3, name: "紫色" },
        { id: 4, name: "白色" },
      ],
      color_i: 0,
      banben: [
        { id: 0, name: "128G" },
        { id: 1, name: "256G" },
        { id: 2, name: "512G" },
        { id: 3, name: "1TB" },
      ],
      banben_i: 0,
      taocan: [
        { id: 0, name: "官方标配" },
        { id: 2, name: "标配+快充" },
      ],
      taocan_i: 0,
    };
  },
  computed: {
    // 滚动
    atEndOfList() {
      return (
        this.currentOffset <=
        this.paginationFactor * -1 * (this.imgs.length - this.windowSize)
      );
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },

    getTotal() {
      const { day, adult, child } = this.submit;
      if (!day) {
        return "--";
      }
      const { adult_price, child_price } = day;
      return parseFloat((adult_price * adult + child_price * child).toFixed(2));
    },
    getGroups() {
      const { month } = this.submit;
      const obj = this.tourGroups[month];
      return obj ? obj.date : [];
    },
    dialogImgs() {
      const { pic_arr } = this.dialog;
      if (!pic_arr) {
        return [];
      }
      return pic_arr.split(",").map((v) => this.imgUrl + v);
    },
    imgs() {
      const { pics } = this.info;
      if (!pics) {
        return [];
      }
      return pics.split(",").map((v) => this.imgUrl + v);
    },
    getScrollIndex() {
      const { top } = this;
      if (document.querySelector("#nodes0") === null) {
        return;
      }
      const ids = [
        ...["nodes0", "nodes1"],
        ...(this.info.travel_notices || []).map((v, i) => "nodes" + (i + 2)),
      ];
      const y = ids
        .map((v, i) => {
          const dom = document.querySelector(`#${v}`);
          return {
            top: dom ? dom.offsetTop : 1000000,
            index: i,
          };
        })
        .reverse();
      const r = y.find((v) => top > v.top - 45);
      const index = r ? r.index : 0;
      return index;
    },
  },
  filters: {
    checkFood(val) {
      return val === "1" ? "icon-gou" : "icon-clear";
    },
  },
  created() {
    const { id } = this.$route.params;
    this.getInfo(id);
    this.scrollTo(0, false);
    window.addEventListener("scroll", this.bodyScroll);
  },
  methods: {
    // 滑块左右点击
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
    // 鼠标事件
    mover(e) {
      this.i = e;
      this.im = e;
    },
    // 点击滑块显示红色
    dianji(e) {
      this.im = e;
    },
    // 选择日期
    dataSearch(value) {
      if (value == null) {
        this.shuliang = false;
      } else {
        this.shuliang = true;
      }
    },
    // 成人数量
    datanumberadult(value) {
      if (value == 0 && this.submit.child == 0) {
        this.hangban = false;
      } else {
        this.hangban = true;
      }
    },
    // 小孩数量
    datanumberchild(value) {
      if (value == 0 && this.submit.adult == 0) {
        this.hangban = false;
      } else {
        this.hangban = true;
      }
    },

    //
    colors(e) {
      this.color_i = e;
    },
    banbens(e) {
      this.banben_i = e;
    },
    taocans(e) {
      this.taocan_i = e;
    },

    openDialog(v) {
      this.dialog = v;
      this.showDialog = true;
    },
    bodyScroll() {
      const top = document.documentElement.scrollTop;
      this.top = top;
    },
    toDom(i) {
      const top = document.querySelector(`#nodes${i}`).offsetTop;
      this.scrollTo(top - 43);
    },
    addOrder() {
      const { day, adult, child } = this.submit;
      if (!day) {
        this.$message.warning("请选择日期!");
        return;
      }
      if (adult === 0 && child === 0) {
        this.$message.warning("请至少选择1名成员!");
        return;
      }
      const { info } = this;
      const data = { info, ...this.submit };
      sessionStorage.setItem("tourOrder", JSON.stringify(data));
      this.$router.push({ name: "tour_add", params: data });
    },
    async getInfo(id) {
      const info = await $tour.detail(id);
      this.info = info;
      this.getTourGroups();
    },
    getTourGroups() {
      const { info } = this;
      if (info.tourgroups.length === 0) {
        const y = moment().get("year");
        const m = moment().get("month");
        const maxDay = moment().endOf("month").format("DD");
        const minWeekday = moment().startOf("month").weekday();
        const date = [
          ...Array.from({ length: minWeekday }, () => ({
            on: false,
            day: null,
          })),
          ...Array.from({ length: maxDay }, (x, i) => ({
            day: i + 1,
            on: false,
          })),
        ];
        let tourGroups = [{ y, m, date }];
        this.tourGroups = tourGroups;
        return;
      }
      // 重组日历函数，按月分组
      let tourGroups = info.tourgroups
        .reduce((arr, v) => {
          const y = moment(v.departure_date).get("year");
          const m = moment(v.departure_date).get("month");
          const i = arr.findIndex((v) => v.y === y && v.m === m);
          const v2 = {
            ...v,
            adult_price: v.adult_price || info.adult_price,
            child_price: v.child_price || info.child_price,
            need_passport: info.need_passport,
            tour_days: info.tour_days,
            city_text: info.city_text,
          };
          if (i === -1) {
            arr.push({ y, m, minPrice: v2.adult_price, date: [v2] });
          } else {
            if (v2.adult_price < arr[i].minPrice) {
              arr[i].minPrice = v2.adult_price;
            }
            arr[i].date.push(v2);
          }
          return arr;
        }, [])
        // 填充当月完整日历，匹配对应日期的信息
        .map((v) => {
          const date = moment(v.date[0].departure_date);
          const maxDay = date.endOf("month").format("DD");
          const minWeekday = date.startOf("month").weekday();
          const days = v.date.map((v) =>
            Number(v.departure_date.split("-")[2])
          );
          let months = Array.from({ length: maxDay }, (x, i) => ({
            day: i + 1,
            on: false,
          })).map((s) => {
            const i = days.findIndex((d) => d === s.day);
            return i === -1
              ? s
              : { ...s, on: true, ...v.date[i], y: v.y, m: v.m };
          });
          months = [
            ...Array.from({ length: minWeekday % 7 }, () => ({
              day: "",
              on: false,
            })),
            ...months,
          ];
          v.date = months;
          return v;
        });
      this.tourGroups = tourGroups;
    },
    changeSubmit(attr, val) {
      const submit = { ...this.submit, [attr]: val };
      this.submit = submit;
    },
    changeDay(item) {
      const { on } = item;
      if (!on) {
        return;
      }
      this.changeSubmit("day", item);
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.bodyScroll);
  },
};
</script>

<style  src="./detail.css"></style>